export const maxGuestCountTip = (
  maxParty: number | string,
  phone: string | null,
) =>
  `Given a Maximum Guest Count of ${maxParty}, when a person seeking a ` +
  'reservation sets the guest count higher than this number, they ' +
  `will see the message “For parties of ${Number(maxParty) + 1} or more ` +
  `guests, please call ${phone || 'the restaurant directly'}.” ` +
  'Listings should not have a max guest count higher than this value.';
